// 产品分类数据
export default [
  {
    id: 1,
    name: 'Mailer Box',
    nameKey: 'mailerBox',
    image: 'https://via.placeholder.com/400x300/e8f5e9/333333?text=Mailer+Box',
    productCount: 120,
    description: 'Custom corrugated mailer boxes for shipping'
  },
  {
    id: 2,
    name: 'Magnetic Gift Box',
    nameKey: 'magneticGiftBox',
    image: 'https://via.placeholder.com/400x300/e3f2fd/333333?text=Magnetic+Box',
    productCount: 85,
    description: 'Luxury magnetic closure gift boxes'
  },
  {
    id: 3,
    name: 'Drawer Box',
    nameKey: 'drawerBox',
    image: 'https://via.placeholder.com/400x300/fce4ec/333333?text=Drawer+Box',
    productCount: 65,
    description: 'Elegant sliding drawer packaging boxes'
  },
  {
    id: 4,
    name: 'Paper Bag',
    nameKey: 'paperBag',
    image: 'https://via.placeholder.com/400x300/f3e5f5/333333?text=Paper+Bag',
    productCount: 95,
    description: 'Custom printed paper shopping bags'
  },
  {
    id: 5,
    name: 'Paper Card',
    nameKey: 'paperCard',
    image: 'https://via.placeholder.com/400x300/e0f7fa/333333?text=Paper+Card',
    productCount: 110,
    description: 'Greeting cards and hang tags'
  },
  {
    id: 6,
    name: 'Catalogue',
    nameKey: 'catalogue',
    image: 'https://via.placeholder.com/400x300/fff3e0/333333?text=Catalogue',
    productCount: 45,
    description: 'Product catalogues and brochures'
  }
]
